<div class="container flex-row flex-place-content-center">
  <mat-card>
    <mat-card-content>
      <mat-spinner></mat-spinner>
    </mat-card-content>
  </mat-card>
</div>
